export const createOperatorRequestLoginUi = operatorId => `REQUEST_LOGIN_${operatorId}`;
